import React from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

export type FilterType = 'provider' | 'gender' | 'language' | 'accent';

interface FilterTag {
	type: FilterType;
	value: string;
}

interface ActiveFiltersProps {
	provider: string;
	gender: string;
	language: string;
	accent: string;
	onClearFilter: (filterType: FilterType) => void;
}

const ActiveFilters: React.FC<ActiveFiltersProps> = ({
	provider,
	gender,
	language,
	accent,
	onClearFilter,
}) => {
	const activeFilters: FilterTag[] = [
		{ type: 'provider' as FilterType, value: provider },
		{ type: 'gender' as FilterType, value: gender },
		{ type: 'language' as FilterType, value: language },
		{ type: 'accent' as FilterType, value: accent },
	].filter((f) => f.value !== 'All');

	if (activeFilters.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-wrap items-center gap-2 mb-4">
			{activeFilters.map((filter) => (
				<span
					key={filter.type}
					className="inline-flex items-center px-3 py-1 rounded-full text-sm 
                   bg-gray-50 border border-gray-200 text-gray-900 
                   hover:border-gray-300 hover:bg-gray-100 transition-colors"
				>
					<span className="capitalize">
						{filter.type}: {filter.value}
					</span>
					<CloseOutlined
						className="ml-2 cursor-pointer hover:text-black"
						onClick={() => onClearFilter(filter.type)}
					/>
				</span>
			))}
			{activeFilters.length > 1 && (
				<Button
					type="link"
					size="small"
					onClick={() => {
						onClearFilter('provider');
						onClearFilter('gender');
						onClearFilter('language');
						onClearFilter('accent');
					}}
					className="text-gray-600 hover:text-gray-900"
				>
					Clear all
				</Button>
			)}
		</div>
	);
};

export default ActiveFilters;
